import { Chip } from "@mui/material";
import { useTranslate } from "react-admin";
import CustomFilterText from "../unit/CustomFilterText";

const QuickFilter = ({
  label,
}: {
  label: string;
  source?: string;
  defaultValue?: any;
}) => {
  const translate = useTranslate();
  return <Chip sx={{ marginBottom: 1 }} label={translate(label)} />;
};

export const getBankerListFilters = () => [
  <CustomFilterText label="Banker #" source="id" defaultValue="" />,
  <CustomFilterText label="Borrower Name" source="name" defaultValue="" />,
  <CustomFilterText label="Email" source="email" defaultValue="" />,
  <CustomFilterText label="Mobile" source="mobile" defaultValue="" />,
];
